// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPersonArrow = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path fillRule="evenodd" d="M7 6a4 4 0 118 0 4 4 0 01-8 0m4-2a2 2 0 100 4 2 2 0 000-4" />,
    <path d="M5 15.941V19h6v2H3v-5.914l.293-.293c.892-.892 2.166-1.582 3.502-2.05C8.14 12.274 9.626 12 11 12v2c-1.126 0-2.39.227-3.545.631-.992.348-1.848.806-2.455 1.31M17.672 17.5H12v-2h5.672l-3-3H17.5l4 4-4 4h-2.828z" />
  );
export default SvgIconPersonArrow;
